export enum SelectOptionState {
	Selected = 'selected',
	NoSelection = 'no-selection',
	NotSelected = 'not-selected',
}
